import router from '@/router'
import store from './store'
import { /* Message, */ MessageBox } from 'element-ui'

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  var authorities = sessionStorage.getItem('authorities') || ''
  // authorities = '015,01501,0150n,01503' // 测试用
  if (to.meta.requiresAuth) {
    next()
  }
  else if (store.getters.token) { // 有 token
    // console.log(to.path)
    if (to.path === '/' || to.path === '/Index') {
      if (authorities.indexOf('01502') > -1) next({ path: '/monitor' })
      else if (authorities.indexOf('01503') > -1) next({ path: '/eventPage' })
      else {
        setTimeout(() => {
          MessageBox.alert('无使用权限')
        }, 200)
        next({ path: '/login' })
      }
    } else if ((to.path === '/monitor' && authorities.indexOf('01502') === -1) ||
      (to.path === '/enlargePage' && authorities.indexOf('01502') === -1) ||
      (to.path === '/eventPage' && authorities.indexOf('01503') === -1) ||
      (to.path === '/eventPageTo' && authorities.indexOf('01503') === -1)||
      (to.path === '/ioRecord' && authorities.indexOf('01506') === -1)
    ) {
      //   var continuStay = true
      MessageBox.confirm('无访问权限，是否继续留在该页面？', '无权限', {
        confirmButtonText: '继续访问',
        cancelButtonText: '重新登录',
        type: 'warning'
      }).catch(() => {
        location.href = '#/login'
        location.reload()
        // next({path:'/login'})
      })
      return
    } else {
      next()
    }
  } else { // 没 token
    if (whiteList.indexOf(to.path) !== -1) { // 白名单路径
      next()
    } else {
      next('/login')
    }
  }
})

router.afterEach(() => {
  // setTimeout(() => {
  //     const browserHeaderTitle = store.getters.browserHeaderTitle
  //     setTitle(browserHeaderTitle)
  // }, 0)
})



// WEBPACK FOOTER //
// ./src/permission.js